import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import { AppProvider } from '@shopify/polaris';
import enTranslations from '@shopify/polaris/locales/en.json';

import './App.css';
//import '@shopify/polaris/styles.css';
import '@shopify/polaris/dist/styles.css';

import Home from './components/Home';
import DeliveryEstimate from './components/DeliveryEstimate';
import ProductDeliveryEstimate from './components/DeliveryEstimate/Product';
import DeliveryTimeSettings from './components/DeliveryEstimate/Settings';
import Install from './components/Install';
import AuthRoute from './components/AuthRoute';
import NewProductGroup from './components/ProductGroup/New';
import EditProductGroup from './components/ProductGroup/Edit';

function App(props: any) {
    console.log('App Component',props)
  return (
    <AppProvider i18n={enTranslations}>
        <Router>
            <Switch>
                <AuthRoute exact path="/" component={Home} />
                <AuthRoute exact path="/delivery-estimate" component={DeliveryEstimate} />
                <AuthRoute exact path="/delivery-estimate/product/:handle" component={ProductDeliveryEstimate} />
                <AuthRoute exact path="/delivery-estimate/settings" component={DeliveryTimeSettings} />
                <AuthRoute path="/product/:handle" component={EditProductGroup} />
                <AuthRoute exact path="/product-group/new" component={NewProductGroup} />
                <Route path="/install">
                    <Install />
                </Route>
            </Switch>
        </Router>
    </AppProvider>
  );
}

export default App;
